module.exports = __webpack_public_path__ + "static/media/dog_and_cat.86b5e8b1.jpeg";